<template>
  <div class="signup-types">
    <!-- <apple-integration-btn /> -->
    <HelperBtn v-if="showList" @click.native="handleClose()">
      <strong>x</strong>
    </HelperBtn>
    <transition name="fade" mode="out-in">
      <div v-if="showList && showForm">
        <SignUpPartnerForm v-if="showForm === 1" @cancel="handleClose()" @authenticated="redirectToHome()"/>
        <playphone-login v-else />
      </div>
      <div key="p1" v-else-if="showList" class="signup-types__list">
        <div>
          <big><strong>{{ $t('auth.signUp.partners.title') }}</strong></big>
        </div>
        <div>
          <p>{{ $t('auth.signUp.partners.playphone.text') }}</p>
          <btn @click="redirectToPartnerForm" class="integration-btn" id="checkout-cadastro-cta-cadastrar-playphone">
            <span>{{ $t('auth.signUp.partners.playphone.cta') }}</span>
          </btn>
        </div>
      </div>
      <div key="p2" v-else>
<!--        <div>-->
<!--          <p>{{ $t('auth.signUp.methods.facebook') }}</p>-->
<!--          <facebook-integration-btn class="btn" @authenticated="$emit('authenticated')" id="checkout-cadastro-cta-cadastrar-via-facebook" />-->
<!--        </div>-->
        <div>
          <p>{{ $t('auth.signUp.methods.partner') }}</p>
          <btn @click="showList = true" flat class="facebook-integration integration-btn" id="checkout-cadastro-cta-cadastrar-via-parcerias">
            <heart-icon class="icon" />
            <!-- <span v-t.preserve="'auth.facebook.signUp'" /> -->
            <span>{{ $t('auth.signUp.methods.partnerCta') }}</span>
          </btn>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import { required, email, minLength } from 'vuelidate/lib/validators'
// import { AuthenticationPlatform } from '@/api/peanutbutter'
// import authenticationService from '@/js/AuthenticationService'
import formSubmit from '@/js/mixins/formSubmit'
import SignUpPartnerForm from './SignUpPartnerForm.vue'
import PlayphoneLogin from '../auth/methods/PlayphoneLogin.vue'
// import { ifoodEmail } from '@/js/validationUtils'

export default {
  components: { SignUpPartnerForm, PlayphoneLogin },
  name: 'sign-up-partner',
  mixins: [formSubmit('signup')],
  data: () => ({
    showList: false,
    showForm: false
  }),
  methods: {
    handleClose () {
      if (this.showForm) {
        this.showForm = false
        setTimeout(() => { // account for css transition on parent component
          this.$emit('partner-form', false)
        }, 300)
      } else {
        this.showList = false
      }
    },
    redirectToPartnerForm() {
      this.$router.push({ path: '/parcerias/playhub' })
    },
    redirectToHome() {
      this.$router.push({ path: '/browse' })
    }
  }
}
</script>

<style lang="scss" scoped>
.signup-types {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  .helper-btn {
    position: absolute;
    right: 1.1rem;
    top: 1rem;
    cursor: pointer;
    display: block;
    strong {
      font-size: 1.4rem;
      line-height: 1.2rem;
      color: white
    }
  }
  >div>div {
    display: flex;
    flex-direction: column;
    margin: 1rem 0
  }
  &__list {
    position: relative;
  }
  p {
    font-size: 1.2rem;
    font-weight: 500;
  }
  .input-container {
    & > .consent-box {
      margin-bottom: 12px;
    }

    & > span {
      text-align: center;
      margin-bottom: 8px;
      font-weight: normal;

      &:last-child {
        margin-top: 8px;
      }
    }
    .btn {
    width: 100%;
    }
  }

  @media screen and (min-width: 1200px) {
    .input-container {
      & > .btn {
        margin-bottom: 16px;
      }

      & > span {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
